import React from 'react';
import cx, { Argument as ClassNameType } from 'classnames';

import { MDText } from 'i18n-react';

import { ArrowDownIcon, IconText, TickCircleIcon } from '@motorway/mw-highway-code';

import cypressIds from 'CypressId';

import { applyCypressData } from 'Utilities/index';

import LocalTexts from '../../../VehicleProfilingTexts.json';
import { useGetSectionComplete } from '../../ConfirmDetails.hooks';

import styles from './SectionHead.scss';

const LocalT = new MDText(LocalTexts);

type SectionHeadProps = {
  className?: ClassNameType;
  desc?: React.ReactNode;
  isOpen: boolean;
  isReadOnly?: boolean;
  state: string;
  title?: React.ReactNode;
  toggleIsOpen: () => void;
};

export const SectionHead = ({
  className, desc = '', isOpen, isReadOnly = false, state, title = '', toggleIsOpen,
}: SectionHeadProps) => {
  const { completed, isActive, isComplete } = useGetSectionComplete(isReadOnly, state);

  const statusText = () => {
    if (isReadOnly) {
      return <p data-thc-style-override>{desc}</p>;
    }

    if (isActive) {
      return null;
    }

    if (isComplete) {
      return (
        <IconText
          icon={() => <TickCircleIcon filled={false} size="xsmall" />}
          text={LocalT.translate('confirmDetails.confirmed')}
          variant="xsmall--regular"
        />
      );
    }

    return <p data-thc-style-override>{LocalT.translate('confirmDetails.unconfirmed')}</p>;
  };

  return (
    <div className={cx(styles.content, styles[isReadOnly ? 'completed' : state], className, { [styles.isOpenBlock]: isOpen })} {...applyCypressData(cypressIds.sections.sectionHeader)}>
      <div className={styles.contentText}>
        <h3>{title}</h3>
        <span className={cx(
          styles.status,
          {
            [styles.hide]: isActive || isOpen,
            [styles.info]: isReadOnly,
          },
        )}
        >
          {statusText()}
        </span>
      </div>
      {completed && (
        <button
          aria-expanded={isOpen}
          className={cx(styles.arrow, { [styles.isOpen]: isOpen })}
          {...applyCypressData(cypressIds.buttons.arrow)}
          onClick={toggleIsOpen}
          type="button"
        >
          <ArrowDownIcon data-thc-arrow-icon />
        </button>
      )}
    </div>
  );
};
